// extracted by mini-css-extract-plugin
export default {"close":"close-module__close___tlTkc","close__icon":"close-module__close__icon___ENGJg"};